import { supabase } from "@/lib/supabase";

export type ImageTransform = {
  width?: number;
  height?: number;
  quality?: number;
  resize?: "cover" | "contain" | "fill";
};

// `resize: 'contain'` keeps the original aspect ratio inside the requested
// width — without it the Supabase proxy defaults to `cover` and, given only a
// width, crops to a square (width × width). Tiles then re-crop via CSS
// `object-cover`, producing the deformed "sliver" we hit on 2026-04-29.
export const TRANSFORMS = {
  feedCard: { width: 800, quality: 82, resize: "contain" as const },
  gridThumb: { width: 600, quality: 82, resize: "contain" as const },
};

export async function signedMemoryImageUrl(
  path: string,
  transform?: ImageTransform,
  expiresIn = 86400,
): Promise<string | null> {
  const { data } = await supabase.storage
    .from("memory-images")
    .createSignedUrl(path, expiresIn, transform ? { transform } : undefined);
  return data?.signedUrl ?? null;
}
